import React, { FC } from 'react'
import BootstrapTable from 'react-bootstrap-table-next'
import ToolkitProvider from 'react-bootstrap-table2-toolkit'
import { formatUTCDate } from '../../../utils/stringTools'
import Activity from '../../../types/Activity'

interface Props {
  activities: Array<Activity>;
}

const formatDateColumn = (cellContent, row) => formatUTCDate(cellContent)

const ActivityLog: FC<Props> = ({ activities }: Props) => {

  const columns = [{
    dataField: 'date',
    text: 'Date Submitted',
    sort: true,
    formatter: formatDateColumn
  }, {
    dataField: 'activity',
    text: 'Activity',
    sort: true,
    headerStyle: (column, colIndex) => {
      return { width: '60%' }
    }
  }, {
    dataField: 'username',
    text: 'Username/Email',
    sort: true
  }]

  return (
    <div>
      <ToolkitProvider
        keyField='providerApplicationActivityId'
        bootstrap4
        data={activities}
        columns={columns}
        search
      >
        {
          (props: any) => (
            <BootstrapTable
              id='provider-application-activity-table'
              bordered={false}
              condensed
              bootstrap4
              noDataIndication={() => <div>No Activity found.</div>}
              { ...props.baseProps }
            />
          )
        }
      </ToolkitProvider>
    </div>
  )
}

export default ActivityLog